export const BEGIN_LOAD_REPORTS_FOR_USER = "BEGIN_LOAD_REPORTS_FOR_USER";
export const END_LOAD_REPORTS_FOR_USER_SUCCESS = "END_LOAD_REPORTS_FOR_USER_SUCCESS";
export const END_LOAD_REPORTS_FOR_USER_ERROR = "END_LOAD_REPORTS_FOR_USER_ERROR";
export const BEGIN_LOAD_EMBED_INFO = "BEGIN_LOAD_EMBED_INFO";
export const END_LOAD_EMBED_INFO_SUCCESS = "END_LOAD_EMBED_INFO_SUCCESS";
export const END_LOAD_EMBED_INFO_ERROR = "END_LOAD_EMBED_INFO_ERROR";
export const CLEAR_EMBED_INFO = "CLEAR_EMBED_INFO";

export interface ReportForUser {
    userName: string | null;
    workspaceId: string | null;
    reportId: string | null;
    reportName: string | null;
}

export interface ReportsForUser {
    isLoading?: boolean;
    userReports?: ReportForUser[];
    error: string | null;
}

export interface EmbedReport {
    reportId: string;
    reportName: string;
    embedUrl: string;
}

export interface EmbedToken {
    token: string | null;
    tokenId: string | null;
    expiration: string | null;
}

export interface EmbedPbiInfo {
    type: string | null;
    embedReport: EmbedReport[];
    embedToken: EmbedToken;
}

export interface EmbedInfo {
    isLoading?: boolean;
    error: string | null;
    embedPbiInfo: EmbedPbiInfo;
}

interface BeginLoadReportsForUserAction {
    type: typeof BEGIN_LOAD_REPORTS_FOR_USER;
}

interface EndLoadReportsForUserSuccessAction {
    type: typeof END_LOAD_REPORTS_FOR_USER_SUCCESS;
    userReports: ReportForUser[];
}

interface EndLoadReportsForUserErrorAction {
    type: typeof END_LOAD_REPORTS_FOR_USER_ERROR;
    error: string;
}

interface BeginLoadEmbedInfoAction {
    type: typeof BEGIN_LOAD_EMBED_INFO;
}

interface EndLoadEmbedInfoSuccessAction {
    type: typeof END_LOAD_EMBED_INFO_SUCCESS;
    embedPbiInfo: EmbedPbiInfo;
}

interface EndLoadEmbedInfoErrorAction {
    type: typeof END_LOAD_EMBED_INFO_ERROR;
    error: string;
}

interface ClearEmbedInfoAction {
    type: typeof CLEAR_EMBED_INFO;
}

export type EmbedInfoActionTypes = BeginLoadReportsForUserAction
    | EndLoadReportsForUserSuccessAction
    | EndLoadReportsForUserErrorAction
    | BeginLoadEmbedInfoAction
    | EndLoadEmbedInfoSuccessAction
    | EndLoadEmbedInfoErrorAction
    | ClearEmbedInfoAction;
